import toast from '../slices/toast';
import type { RootStateType } from '../index';

export const {
    setMessage
} = toast.actions;

export const selectMessage = () => (state: RootStateType) => state.toast.message;
